import {
  FieldErrorContext,
  FieldError as RACFieldError,
  type FieldErrorProps as RACFieldErrorProps,
  Group as RACGroup,
  type GroupProps as RACGroupProps,
  Input as RACInput,
  type InputProps as RACInputProps,
  Label as RACLabel,
  type LabelProps as RACLabelProps,
  Text as RACText,
  TextArea as RACTextArea,
  type TextAreaProps as RACTextAreaProps,
  TextField as RACTextField,
  type TextFieldProps as RACTextFieldProps,
  type TextProps as RACTextProps,
} from "react-aria-components";

export { FieldErrorContext };

export interface TextFieldProps extends RACTextFieldProps {}
export interface TextFieldLabelProps extends RACLabelProps {}
export interface TextFieldGroupProps extends RACGroupProps {
  /** React 19 ref-as-prop; forwarded to the underlying RAC Group element. */
  ref?: React.Ref<HTMLDivElement>;
}
export interface TextFieldInputProps extends RACInputProps {}
export interface TextFieldTextAreaProps extends RACTextAreaProps {}
export interface TextFieldDescriptionProps extends Omit<RACTextProps, "slot"> {}
export interface TextFieldTextProps extends RACTextProps {}
export interface TextFieldErrorProps extends RACFieldErrorProps {}

export function TextField(props: TextFieldProps) {
  return <RACTextField {...props} />;
}

export function TextFieldLabel(props: TextFieldLabelProps) {
  return <RACLabel {...props} />;
}

export function TextFieldGroup(props: TextFieldGroupProps) {
  return <RACGroup {...props} />;
}

export function TextFieldInput(props: TextFieldInputProps) {
  return <RACInput {...props} />;
}

export function TextFieldTextArea(props: TextFieldTextAreaProps) {
  return <RACTextArea {...props} />;
}

export function TextFieldDescription(props: TextFieldDescriptionProps) {
  return <RACText {...props} slot="description" />;
}

export function TextFieldText(props: TextFieldTextProps) {
  return <RACText {...props} />;
}

export function TextFieldError(props: TextFieldErrorProps) {
  return <RACFieldError {...props} />;
}
